<template>
  <div ref="topForm">
    <v-stepper v-model="currentFormStep" elevation="0" alt-labels>
      <v-container class="pa-0">
        <!-- *** USED FOR DEBUGGING FORM STEP PAGES *** -->
        <!-- <v-stepper-header class="stepper-header" sm="6">
          <template v-for="step in numberOfSteps">
            <v-stepper-step
              :key="`${step}` + '-step'"
              :complete="currentFormStep > step"
              :step="step"
              editable
            >
              <div class="secondary--text" align="center">
                <b> Step {{ step }}:<br /> </b>
              </div>
            </v-stepper-step>

            <v-divider v-if="step !== numberOfSteps" :key="step"></v-divider>
          </template>
        </v-stepper-header> -->

        <S7_Summary :formSubmissionData="store.formSubmissionData" />

        <S1_OrderInfo
          v-show="store.orderInfo.type == 'Merchandise'"
          :cart="parsedCartData"
          @nextStepFromOne="nextStep"
        />

        <S2_DonationInfo
          :hasRegistration="
            store.orderInfo.selection != undefined &&
            (store.orderInfo.selection.includes('Registration') ||
              store.orderInfo.selection.includes('Register and/or Donate'))
              ? true
              : false
          "
          @nextStepFromTwo="nextStep"
          @previousStepFromTwo="previousStep"
        />

        <S3_RegistrationInfo
          :orderPhoneNumber="store.orderInfo.phoneNumber"
          @nextStepFromThree="nextStep"
          @previousStepFromThree="previousStep"
        />

        <S4_Waiver
          @nextStepFromFour="nextStep"
          @previousStepFromFour="previousStep"
        />

        <S5_PaymentInfo
          :postalCode="store.registrationInfoFormData.registrationPostalCode"
          @nextStepFromFive="nextStep"
          @previousStepFromFive="previousStep"
          @formSubmittedDigitalPayment="validateFormSubmissionDigitalPayment"
        />

        <S6_Confirmation
          :donationAmount="store.donationInfoFormData.donationAmount"
          :merchAmount="store.orderInfo.merchTotal"
          @formSubmitted="validateFormSubmission"
          @previousStepFromSix="previousStep"
        />

        <FormNotFound v-show="showFormNotFound" />
      </v-container>
    </v-stepper>
  </div>
</template>

<script>
import S1_OrderInfo from "./FormSteps/S1_OrderInfo.vue";
import S2_DonationInfo from "./FormSteps/S2_DonationInfo.vue";
import S3_RegistrationInfo from "./FormSteps/S3_RegistrationInfo.vue";
import S4_Waiver from "./FormSteps/S4_Waiver.vue";
import S5_PaymentInfo from "./FormSteps/S5_PaymentInfo.vue";
import S6_Confirmation from "./FormSteps/S6_Confirmation.vue";
import S7_Summary from "./FormSteps/S7_Summary.vue";
import FormNotFound from "./FormNotFound.vue";

import axios from "axios";
import { useFormDataStore } from "../../store/formData";

export default {
  name: "Form",
  data: () => {
    return {
      currentFormStep: 1,
      numberOfSteps: 7,
      formCompleted: false,
      parsedCartData: [],
      showFormNotFound: false,
    };
  },
  setup() {
    const store = useFormDataStore();

    return {
      store,
    };
  },
  components: {
    S1_OrderInfo,
    S2_DonationInfo,
    S3_RegistrationInfo,
    S4_Waiver,
    S5_PaymentInfo,
    S6_Confirmation,
    S7_Summary,
    FormNotFound,
  },
  async created() {
    let urlParams = new URLSearchParams(window.location.search);

    try {
      await axios
        .post(process.env.VUE_APP_BASE_URL_API + "form/getOrder", {
          orderId: urlParams.get("id"),
        })
        .then((response) => {
          this.$emit("apiComplete");

          if (
            response.data.success &&
            (response.data.order.status == "Pending" ||
              response.data.order.status == "Declined")
          ) {
            this.store.setOrderInfo(response.data.order);

            this.$i18n.locale = this.store.orderInfo.language;

            // Type: 'Merchandise' | 'RegisterAndDonate'
            // Selection: 'Register and/or Donate' (first 2-4 pages)
            // Selection: 'Registration' (include pages 3-4) and 'Donation' (include page 2)
            if (this.store.orderInfo.type == "Merchandise") {
              this.parsedCartData = Object.values(
                JSON.parse(this.store.orderInfo.cart)
              );
            } else if (
              this.store.orderInfo.type == "RegisterAndDonate" ||
              this.store.orderInfo.selection.includes("Donation")
            ) {
              this.currentFormStep = 2;
            }
          } else if (
            response.data.success &&
            (response.data.order.status == "Approved" ||
              response.data.order.status == "Completed")
          ) {
            if (response.data.order.transactionId) {
              this.store.setFormSubmissionData({
                status: "Approved",
                merchantId: response.data.order.merchantId,
                total: response.data.order.formData.amount,
              });
            }

            this.currentFormStep = 7;
          } else {
            this.showFormNotFound = true;
          }

          // console.log(response);
        });
    } catch (error) {
      this.$emit("apiComplete");

      this.showFormNotFound = true;
    }
  },
  methods: {
    scrollToTop() {
      let element = this.$refs["topForm"];
      let top = element.offsetTop;

      window.scrollTo(0, top);
    },
    nextStep() {
      // Merchandise only
      if (
        this.store.orderInfo.type == "Merchandise" &&
        this.store.orderInfo.selection == "" &&
        this.currentFormStep == 1
      ) {
        this.currentFormStep = 5;
      }
      // Merchandise & Registration
      else if (
        this.store.orderInfo.type == "Merchandise" &&
        !this.store.orderInfo.selection.includes("Donation") &&
        this.currentFormStep == 1
      ) {
        this.currentFormStep = 3;
      }
      // Merchandise & Registration
      else if (
        this.store.orderInfo.type == "Merchandise" &&
        !this.store.orderInfo.selection.includes("Donation") &&
        this.currentFormStep == 4
      ) {
        this.currentFormStep = 5;
      }
      // Merchandise & Donation
      else if (
        this.store.orderInfo.type == "Merchandise" &&
        !this.store.orderInfo.selection.includes("Registration") &&
        this.currentFormStep == 2
      ) {
        this.currentFormStep = 5;
      }
      // Register and/or Donate
      else if (
        this.store.orderInfo.type == "RegisterAndDonate" &&
        this.currentFormStep == 4
      ) {
        if (this.store.donationInfoFormData.donationAmount == 0) {
          this.currentFormStep = 6;
        } else {
          this.currentFormStep = 5;
        }
      }
      // Donate only
      else if (
        this.store.orderInfo.type == "RegisterAndDonate" &&
        this.store.orderInfo.selection.includes("Donation") &&
        this.currentFormStep == 2
      ) {
        if (this.store.donationInfoFormData.donationAmount == 0) {
          this.currentFormStep = 6;
        } else {
          this.currentFormStep = 5;
        }
      } else {
        this.currentFormStep++;
      }

      this.scrollToTop();
    },
    previousStep() {
      // Merchandise only
      if (
        this.store.orderInfo.type == "Merchandise" &&
        this.store.orderInfo.selection == "" &&
        this.currentFormStep == 6
      ) {
        this.currentFormStep = 5;
      }
      // Merchandise only
      else if (
        this.store.orderInfo.type == "Merchandise" &&
        this.store.orderInfo.selection == "" &&
        this.currentFormStep == 5
      ) {
        this.currentFormStep = 1;
      }
      // Merchandise & Registration
      else if (
        this.store.orderInfo.type == "Merchandise" &&
        !this.store.orderInfo.selection.includes("Donation") &&
        this.currentFormStep == 6
      ) {
        this.currentFormStep = 5;
      }
      // Merchandise & Registration
      else if (
        this.store.orderInfo.type == "Merchandise" &&
        !this.store.orderInfo.selection.includes("Donation") &&
        this.currentFormStep == 3
      ) {
        this.currentFormStep = 1;
      }
      // Merchandise & Donation
      else if (
        this.store.orderInfo.type == "Merchandise" &&
        !this.store.orderInfo.selection.includes("Registration") &&
        this.currentFormStep == 6
      ) {
        this.currentFormStep = 5;
      }
      // Merchandise & Donation
      else if (
        this.store.orderInfo.type == "Merchandise" &&
        !this.store.orderInfo.selection.includes("Registration") &&
        this.currentFormStep == 5
      ) {
        this.currentFormStep = 2;
      }
      // Register and/or Donate
      else if (
        this.store.orderInfo.type == "RegisterAndDonate" &&
        this.store.orderInfo.selection.includes("Register and/or Donate") &&
        this.currentFormStep == 6
      ) {
        if (this.store.donationInfoFormData.donationAmount == 0) {
          this.currentFormStep = 4;
        } else {
          this.currentFormStep = 5;
        }
      }
      // Donate only
      else if (
        this.store.orderInfo.type == "RegisterAndDonate" &&
        this.store.orderInfo.selection.includes("Donation")
      ) {
        if (
          this.store.donationInfoFormData.donationAmount == 0 &&
          this.currentFormStep == 6
        ) {
          this.currentFormStep = 2;
        } else {
          // Donate only (get tax receipt information)
          if (this.currentFormStep == 6) {
            this.currentFormStep = 5;
          } else {
            this.currentFormStep = 2;
          }
        }
      } else {
        this.currentFormStep--;
      }
      this.scrollToTop();
    },
    validateFormSubmission() {
      if (this.store.formSubmissionData.status != "Approved") {
        this.currentFormStep = 5;
      } else {
        this.nextStep();
      }
    },
    validateFormSubmissionDigitalPayment() {
      if (this.store.formSubmissionData.status != "Approved") {
        this.currentFormStep = 5;
      } else {
        this.currentFormStep = 7;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
